import React, { useState } from 'react';

export type AlertColor = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';
export interface AlertProps {
  messages: string[] | JSX.Element[];
  title?: string;
  color?: AlertColor;
  noHeading?: boolean;
  dismiss?: boolean;
}

const capitalizeFirst = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const getHeading = (color?: AlertColor) => {
  switch (color) {
    case 'danger':
      return 'An error occurred';
    default:
      return capitalizeFirst(color || 'Title');
  }
};

export const Alert: React.FC<AlertProps> = (props) => {
  const [visible, setVisible] = useState<boolean>(true);

  const onDismiss = () => {
    setVisible(false);
  };

  if (!props.messages || props.messages.length == 0) return <></>;

  return (
    <>
      {visible && (
        <div className={`alert alert-${props.color || 'danger'} ${props.dismiss ? 'alert-dismissible' : ''} fade show`} role="alert">
          {!props.noHeading && (
            <div className="row">
              <div className="col">
                <h4 className="alert-heading">{props.title || getHeading(props.color || 'danger')}</h4>
              </div>
            </div>
          )}
          {props.messages.map((m: string | JSX.Element, i: number) => {
            return (
              <React.Fragment key={i}>
                {i !== 0 && (
                  <>
                    <div className="row">
                      <div className="col">
                        <hr />
                      </div>
                    </div>
                  </>
                )}
                <div className="row">
                  <div className="col">
                    <p className="mb-0">{m}</p>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
          {props.dismiss && (
            <button
              type="button"
              className="close"
              data-dismiss="alert"
              aria-label="Close"
              onClick={() => {
                onDismiss();
              }}>
              <span aria-hidden="true">&times;</span>
            </button>
          )}
        </div>
      )}
    </>
  );
};
